import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useMainStore } from "@/stores/main";
import Tool from "@/components/tools/Tool.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'WinnerTakesAllSwitch',
  setup(__props) {

const store = useMainStore();

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createBlock(Tool, {
    label: "Winner Takes All",
    "for-switch": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_switch, {
        modelValue: _unref(store).winnerTakesAll,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).winnerTakesAll) = $event)),
        class: "WinnerTakesAll"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})